<!--
TODO: エラーの解消
  vue.runtime.esm.js:638 [Vue warn]: Error in render: "TypeError: Cannot read properties of undefined (reading 'label')"
-->
<template>
  <div>
    <ul class="v-presetList">
      <li class="v-presetList__item" v-for="(values, key) in searchPresets" :key="key.label">
        <button type="button"
          :class="['v-presetButton', crtPreset == key ? 'is-crt' : '']"
          @click="searchByPreset(searchPresets[key]); updateCrtPreset(key);"
        >
          <span class="v-presetButton__inner" v-if="searchPresets[key]" v-text="searchPresets[key]['label']"></span>
        </button>
      </li>

    </ul>
    <p v-if='crtPreset !== ""' v-html="searchPresets[crtPreset]['description']"></p>
  </div>
</template>

<script>
export default {
  name: 'FilterPresets',
  props: {
    searchPresets: { type: Object, required: true },
    crtPreset: { type: String, required: true },
  },
  methods: {
    updateCrtPreset (str) {
      this.$emit('updateCrtPreset', str);
    },
    searchByPreset (preset) {
      this.$emit('searchByPreset', preset);
    },
  }
}
</script>

<style lang="scss" scoped>
  .v-presetList {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;

    @media screen and (min-width: 1200px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .v-presetButton {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent;
    border: 0;
    color: inherit;
    font: inherit;
    padding: 0;
    outline: 0;
    letter-spacing: inherit;
    text-align: inherit;

    text-align: center;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    border: 1px solid rgba(214, 214, 214, .5);
    border-radius: 2px;
    text-decoration: none;
    min-height: 40px;
    padding: 5px;
    transition: .2s;

    &.is-crt {
      background: #2a475a;
      border-color: #2a475a;
      color: #fff;
    }
  }
</style>